<template>
<div class="d-flex flex-column h-100">
    <header class="masthead mb-auto">
      <nav class="navbar navbar-expand-lg navbar-dark bg-no-trans">
        <div class="container">
          <a class="navbar-brand" href="/#/">
            <img src="../../assets/img/logo.png" alt="Logo" />
          </a>
          <div class="my-2 my-lg-0">
            <button
              class="btn btn-light btn-sm my-2 my-sm-0"
              @click="gotoSingin"
            >
              Login
            </button>
          </div>
        </div>
      </nav>
    </header>
    <section class="py-5 bg-grey200">
      <div class="container">
        <div class="row d-flex justify-content-center">
          <div class="col-md-6">
            <ul class="list-group checkout-list-group">
              <li class="list-group-item">
                <h4 class="text-center">Almost Done!</h4>
                <p class="text-center">
                  Review your plan and checkout To start watching
                </p>
              </li>
              <li class="list-group-item">
                <div
                  class="row d-flex align-items-center justify-content-between"
                >
                  <div class="col-auto label-text">Payment Method</div>
                  <div class="col-auto">
                    <span
                      v-if="$route.params.paymentmethod == 'paypal'"
                      class="img"
                      ><img src="../../assets/img/paypal.png"
                    /></span>
                    <span
                      v-if="$route.params.paymentmethod == 'visa'"
                      class="img"
                      ><img src="../../assets/img/visa.png"
                    /></span>
                    <span
                      v-if="$route.params.paymentmethod == 'mastercard'"
                      class="img"
                      ><img src="../../assets/img/mastercard.png"
                    /></span>
                    <span
                      v-if="$route.params.paymentmethod == 'glo'"
                      class="img"
                      ><img src="../../assets/img/Glo_button.png"
                    /></span>
                    <span
                      v-if="$route.params.paymentmethod == 'ussd'"
                      class="img"
                      ><img src="../../assets/img/ussd.png"
                    /></span>
                    <span
                      v-if="$route.params.paymentmethod == 'tigo'"
                      class="img"
                      ><img src="../../assets/img/tigo.png"
                    /></span>
                    <span
                      v-if="$route.params.paymentmethod == 'mpesa'"
                      class="img"
                      ><img src="../../assets/img/mpesa.png"
                    /></span>
                    <span
                      v-if="$route.params.paymentmethod == 'mtn'"
                      class="img"
                      ><img src="../../assets/img/mtn.png"
                    /></span>
                  </div>
                  <div class="col-auto">
                    <a :href="getPaymentHref()" class="btn btn-outline-primary"
                      >Edit</a
                    >
                  </div>
                </div>
              </li>
              <li class="list-group-item">
                <div
                  class="row d-flex align-items-center justify-content-between"
                >
                  <div class="col text-center relative">
                    <p>Payment plan</p>
                    <h1 class="price">
                      <small>{{ planCurrency }}</small>
                      {{ planPrice }}
                    </h1>
                    <p class="text-green font-semibold">
                      {{ planSub }}
                    </p>
                    <a
											href="/#/packages"
											class="btn btn-outline-primary edit-btn"
											>Change</a
										>
                  </div>
                </div>
              </li>

              <li class="list-group-item">
                <ul class="list">
                  <li>4GB data free</li>
                  <li>14 days free subscription</li>
                  <li>Unlimited movies and Tv shows</li>
                  <li>Watch on your laptop, TV, phone and tablet</li>
                  <li>Cancel anytime</li>
                </ul>
              </li>
              <li class="list-group-item">
                <p>
                  By checking the checkbox below, you agree to our Terms of Use,
									Privacy Statement, and that you are over 18. You may cancel at
									any time. Ibakatv will automatically continue your membership
									and charge the membership fee (currently ₦ {{ planPrice }}) to your payment method on a monthly basis until you
									cancel.
                </p>
                <div class="custom-control custom-checkbox mt-3">
                  <input
                    type="checkbox"
                    v-model="checked"
                    class="custom-control-input"
                    id="customCheck1"
                  />
                  <label class="custom-control-label label-text" for="customCheck1"
                    >I Agree</label
                  >
                </div>
                <div class="text-center">
                  <button
                    @click="processFutterwavePayment"
                    class="btn  btn-outline-light"
                    :disabled="!checked"
                  >
                    START MEMBERSHIP
                  </button>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <p class="text-center pt-4 label-text">Download App</p>
      <p class="text-center">
        <img
          src="../../assets/img/google-play.png"
          alt=""
          class="cursor-pointer"
          @click="gotoAppStore('google')"
        />
        <img
          src="../../assets/img/app-store.png"
          class="ml-2 cursor-pointer"
          alt=""
          @click="gotoAppStore('apple')"
        />
      </p>
    </section>
    <footer class="footer text-dark mt-auto py-3 bg-grey200">
      <div class="container text-center">
        <a href="#nogo">Home</a>
        <a href="#nogo">Privacy Policy</a>
        <a href="#nogo">Terms of Use</a>
        <a href="#nogo">FAQ</a>
      </div>
      <div class="footer-copyright text-center py-2">
        Copyright © 2021. All Rights Reserved by IBAKA Entertainment Inc.
      </div>
    </footer>
  </div>

</template>

<script>
export default {
  name: "FlutterWavePayment",
  components: {
    
  },
  beforeCreate() {
    this.packages = this.$store.state.packages;
    this.$store.dispatch("account").then((res) => {
				if (res) {
					this.data = res.response;
					this.$store.commit("setLoader", false);
				}
			});
  },
  created() {
    var pid = this.$route.params.pid;
    var sid = this.$route.params.sid;
       this.$store.commit("showPopup", false);
    
    const packages = this.$store.getters.getPackages;
    this.slugName = this.getSlugName(packages);
    if (this.$store.getters.getGlobalConfigs.provider_slug) {
      this.provider_slug = this.$store.getters.getGlobalConfigs.provider_slug;
    }
    if (this.$store.getters.getGlobalConfigs.country_name=="Nigeria" && this.$route.query.recurringType=="recurring") {
      this.type = ""
    }
    else{
      this.type="one-time"
    }
    this.currentPackage=this.getSubsById(pid)
    
    var Data = {
				token: this.$store.state.user.accessToken,
			};
			this.$store.dispatch("getClientToken", Data).then((res) => {
				if (res) {
					this.$store.commit("setBTClientToken", res.token);
					this.$store.commit(
						"tempUserToken",
						this.$store.state.user.accessToken
					);
					
				}
			});

    
  },
  methods: {
    getSlugName(packages) {
      var slugName = "";
      for (let i = 0; i < packages.length; i++) {
        for (let j = 0; j < packages[i].subscriptions.length; j++) {
          if (packages[i].subscriptions[j].id == this.$route.params.sid) {
            slugName = packages[i].subscriptions[j].slug_name;
            break;
          }
        }
      }
      return slugName;
    },
    getCurrentsubs() {
      let cp = this.packages.find((ele) => ele.id == this.$route.params.pid);
      return cp.subscriptions.find((ele) => ele.id == this.$route.params.sid);
    },
     getPaymentHref() {
      return (
        "/#/selectpayment-dsp/" +
        this.$route.params.sid +
        "/" +
        this.$route.params.pid
      );
    },
    gotoSingin() {
      this.$router.push("/login");
    },
    getSubsById(pid) {
			var currentPackageObj = this.packages.find((ele) => ele.id == pid);
			return currentPackageObj;
		},
    processFutterwavePayment(){
      this.$store.commit("setLoader", true);
    this.$store
      .dispatch("FlutterWavePaymentProcess", {
        slug: this.slugName,
        provider_slug: this.provider_slug,
        type:this.type
      })
      .then((response) => {
        const url = response.data.link;
        window.open(url, "_self");
        this.$store.commit("setLoader", false);
       // this.$router.push("/");
      })
      .catch((err) => {
        this.$store.commit(
          "setNotification",
          "Something went wrong please try again later"
        );
        this.$router.push("/account");
        this.$store.commit("setLoader", false);
      });
    }
  },
computed: {
		subscription() {
			const subscriptions = this.data.subscriptions;
			let subscriptionString = subscriptions[0].package;

			return subscriptionString;
		},
		email() {
			if (this.data.profile) {
				return this.data.profile.username;
			}
		},
		subs() {
			if(this.data){
			if (this.data.subscriptions.length >= 0) {
				return this.data.subscriptions[0];
			} else {
				return [];
			}
			}
		},

    planCurrency(){
        const sub=this.getCurrentsubs()
      if( sub.currency){
        return sub.currency
      } 
      else { return ""}
    },
    planPrice(){
      const sub=this.getCurrentsubs()
      if( sub.price){
        return sub.price
      } 
      else { return ""}
      
    },

    planSub(){
      const subs=this.getCurrentsubs()
      if( subs.title){
        return subs.title
      } 
      else { return ""}
      
      

    }
	},

  data() {
    return {
      slugName: "",
      provider_slug: "",
      type:"",
      data: null,
      checked: false,
	  currentSubs: null,
 	currentPackage: null,
    };
  },
};
</script>
<style scoped></style>
